import { render } from "./DropdownElement.vue?vue&type=template&id=a3042c6a"
import script from "./DropdownElement.vue?vue&type=script&lang=js"
export * from "./DropdownElement.vue?vue&type=script&lang=js"

import "./DropdownElement.vue?vue&type=style&index=0&id=a3042c6a&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__